import { BusItem } from '@app/entities/bus-results';
import { FlightItem, NewFlightItemVm } from '@app/entities/flight-results';

const POSITION_DESKTOP_ITINERARY_SEPARATOR = '[POSITION_DESKTOP_ITINERARY_SEPARATOR]';

const RT_FLIGHT_KEY_SECTOR_SEPARATOR = '[RT_FLIGHT_KEY_SECTOR_SEPARATOR]';

const URI_HASHTAG = '#';

enum FormatPartType {
  Day = 'day',
  Year = 'year',
  Month = 'month',
  Literal = 'literal',
}

export function flightKeysMapper(selectedSectors: NewFlightItemVm[] | BusItem[]): string {
  let flightKeys;
  selectedSectors.forEach((sector, index) => {
    flightKeys = index === 0 ? `${sector.FlightKeys}` :
      `${flightKeys}${RT_FLIGHT_KEY_SECTOR_SEPARATOR}${sector.FlightKeys}`;
  });
  return flightKeys;
}

export function getFlightKeysWithEncodeURIComponent(flightKeys: string): string {
  return flightKeys?.replace(new RegExp(URI_HASHTAG, 'g'), encodeURIComponent(URI_HASHTAG));
}

export function getUriFlightKeys(flightKeys: string): string {
  let keys = '';
  flightKeys?.split(RT_FLIGHT_KEY_SECTOR_SEPARATOR)?.forEach(key => {
    keys = `${keys}&flightKeys=${key}`;
  });
  return keys;
}

export function flightKeysMobileMapper(selectedFlights: NewFlightItemVm[]): string {
  if (selectedFlights?.every(sector => !!sector?.FlightKeys)) {
    return flightKeysMapper(selectedFlights);
  } else {
    let flightKeys = '';
    selectedFlights.forEach((sector, sectorIndex) => {
      let sectorKeys = '';
      if (sector?.Flights?.length) {
        sector.Flights.forEach((flight, flightIndex) => {
          const keysByFlights = `${flight.AirlineCode}${flight.Number}|${getDateWithKeyFormat(flight.DepartureDate)}`
          sectorKeys = flightIndex === 0 ? keysByFlights : `${sectorKeys}${URI_HASHTAG}${keysByFlights}`;
        });
      } else {
        sectorKeys = `${sector.AirlineCode}_${sectorIndex}:${sector.DepartureAirport}-${sector.ArrivalAirport}:` +
          `${getDateWithKeyFormat(sector.DepartureDate)}-${getDateWithKeyFormat(sector.ArrivalDate)}`;
      }
      flightKeys = sectorIndex === 0 ? sectorKeys :
        `${flightKeys}${RT_FLIGHT_KEY_SECTOR_SEPARATOR}${sectorKeys}`;
    });
    return flightKeys;
  }
}

export function flightKeysDesktopPackageMapper(selectedFlights: FlightItem[], index: number): string {
  return `${index}${POSITION_DESKTOP_ITINERARY_SEPARATOR}${flightKeysMapper(selectedFlights)}`;
}

export function getKeysInPackageMapper(flightKeys: string): string {
  const parts = flightKeys ? flightKeys.split(POSITION_DESKTOP_ITINERARY_SEPARATOR) : null;
  return parts && parts.length && parts[1] ? parts[1] : null;
}

export function geIndexInPackageMapper(flightKeys: string): string {
  const parts = flightKeys ? flightKeys.split(POSITION_DESKTOP_ITINERARY_SEPARATOR) : null;
  return parts && parts.length ? parts[0] : null;
}

function getDateWithKeyFormat(dateString: string): string {
  const date = new Date(dateString);
  const dateParts = new Intl.DateTimeFormat().formatToParts(date);
  const getByType = (type: FormatPartType) => {
    const valueString = dateParts.find(part => part.type === type)?.value;
    const value = valueString && !isNaN(Number(valueString)) ? Number(valueString) : 0;
    return type === FormatPartType.Year ? value : getDateItemValue(value);
  };
  const dateFormat = `${getByType(FormatPartType.Year)}${getByType(FormatPartType.Month)}${getByType(FormatPartType.Day)}`;
  const formatTime = `${getDateItemValue(date.getHours() + 1)}:${getDateItemValue(date.getMinutes() + 1)}`;
  return `${dateFormat} ${formatTime}`;
}

function getDateItemValue(value: number): string {
  return (`0${value}`).slice(-2);
}
